import * as React from "react";
import { required, TextInput } from "react-admin";

const sendgrid = {
  create: () => (
    <TextInput
      inputProps={{ maxLength: 255 }}
      source="config.api_key"
      validate={[required()]}
    />
  ),
};

const emailjs = {
  create: () => (
    <>
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.service_id"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.template_id"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.user_id"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.accessToken"
        validate={[required()]}
      />
    </>
  ),
};

const mailjet = {
  create: () => (
    <>
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.app_name"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.api_key_public"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.api_key_private"
        validate={[required()]}
      />
    </>
  ),
};

const mailtrap = {
  create: () => (
    <>
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.app_name"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.token"
        validate={[required()]}
      />
    </>
  ),
};

const nodemailer = {
  create: () => (
    <>
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.user"
        validate={[required()]}
      />
      <TextInput
        inputProps={{ maxLength: 255 }}
        source="config.password"
        validate={[required()]}
      />
    </>
  ),
};

export default { sendgrid, emailjs, mailjet, mailtrap, nodemailer };
